import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useSearchActions } from 'modules/search/contexts/SearchContext';
import type { SearchFacet } from 'modules/search/types/SearchFacet';
import type { SearchType } from 'modules/search/types/SearchType';

import type { SearchPageLocationState } from './types/SearchPageLocationState';
import { useSearchPageSyncUrlAndFetch } from './useSearchPageSyncUrlAndFetch';

type Args = {
  searchType: SearchType;
  getSearchTrackingData: () => Record<string, unknown>;
  searchFacets: SearchFacet[];
};

export function useSearchPageLifecycle({
  searchType,
  getSearchTrackingData,
  searchFacets,
}: Args) {
  const { updateSearchLocation } = useSearchActions();
  const location = useLocation<SearchPageLocationState>();

  const locationStateSearchLocation = location.state?.searchLocation;
  useEffect(() => {
    if (locationStateSearchLocation)
      updateSearchLocation(locationStateSearchLocation, true);
  }, [locationStateSearchLocation, updateSearchLocation]);

  // Sync & fetch
  const { initialized } = useSearchPageSyncUrlAndFetch({
    searchType,
    getSearchTrackingData,
    searchFacets,
  });

  return { initialized };
}
